import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../../../src/environments/environment';
import {ContactInfo} from './contact-info.model';
import {ReactiveService} from '../reactive-service.abstract';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { extractDomain } from '../../../../src/app/shared/helpers/domain.helper';


@Injectable()
export class ContactApiService extends ReactiveService  {
  public baseUrl = environment.backEndUrlPrefix + '/db';

  constructor(private http: HttpClient) {
    super();
  }

  getContactInfo(): Observable<ContactInfo> {
    return this.http.get<ContactInfo>(this.baseUrl + '/contact',
      { params: { domain: extractDomain(document.location.href) } }
    );
  }

  setContactInfo(contact): Observable<ContactInfo> {
    return this.http.post(`${this.baseUrl}/contact/update`, contact);

  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ContactInfo> | Promise<ContactInfo> | ContactInfo {
    return this.getContactInfo();
  }
}
